module.exports = "#editBody form .row div .form-group{\r\n     margin-top : 5px !important;\r\n}\r\ninput[type=\"file\"] {\r\n    display: none;\r\n}\r\n.custom-file-upload {\r\n    border: 1px solid #ccc;\r\n    display: inline-block;\r\n    padding: 6px 12px;\r\n    cursor: pointer;\r\n    width:100%\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/section/patient/edit-patient/edit-patient.component.css
// module id = ./src/app/section/patient/edit-patient/edit-patient.component.css
// module chunks = main